import { initializeApp, getApps } from "firebase/app";
import { getAuth, browserLocalPersistence, setPersistence } from "firebase/auth";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

// On the production domain, route OAuth through app.seshly.in (vercel.json
// proxies /__/auth/* to Firebase) so Google's consent screen and the address
// bar show our brand instead of sessionlogger-2e5f1.firebaseapp.com.
// Everywhere else (localhost dev, previews) keep the default Firebase domain.
const isProdDomain = typeof window !== "undefined" && window.location.hostname === "app.seshly.in";

const firebaseConfig = {
  apiKey: "AIzaSyAe9fg-7Vt5555PFqFm9VnWAaltwQ7BFc4",
  authDomain: isProdDomain ? "app.seshly.in" : "sessionlogger-2e5f1.firebaseapp.com",
  projectId: "sessionlogger-2e5f1",
  storageBucket: "sessionlogger-2e5f1.firebasestorage.app",
  messagingSenderId: "259632058525",
  appId: "1:259632058525:web:9bd072f874b0f5b59dc474",
  measurementId: "G-9QNE2YVHFX",
};

const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);

// App Check — protects Firestore / Storage / Functions from being called
// by clients other than this app. Set REACT_APP_RECAPTCHA_V3_SITE_KEY in
// the build environment (Vercel / .env.production). In dev, set
// REACT_APP_APPCHECK_DEBUG_TOKEN to a token created in Firebase Console.
if (typeof window !== "undefined") {
  const siteKey = process.env.REACT_APP_RECAPTCHA_V3_SITE_KEY;
  if (process.env.NODE_ENV !== "production" && process.env.REACT_APP_APPCHECK_DEBUG_TOKEN) {
    // eslint-disable-next-line no-restricted-globals
    self.FIREBASE_APPCHECK_DEBUG_TOKEN = process.env.REACT_APP_APPCHECK_DEBUG_TOKEN;
  }
  if (siteKey) {
    try {
      initializeAppCheck(app, {
        provider: new ReCaptchaV3Provider(siteKey),
        isTokenAutoRefreshEnabled: true,
      });
    } catch (err) {
      console.warn("App Check init failed:", err?.message);
    }
  }
}

export const auth = getAuth(app);
// Persistent local cache: listeners fire instantly from IndexedDB on app open,
// then sync deltas in the background. Cuts cold-start data loading and billed
// reads. Multi-tab manager keeps several open tabs sharing one cache safely.
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
});
export const storage = getStorage(app);
export const functions = getFunctions(app, "asia-south1");

setPersistence(auth, browserLocalPersistence).catch(() => {});

export default app;